import React, { FC, useMemo } from "react";
import DateTypographyHeader from "../DateTypographyHeader";
import useTranslations from "./useTranslations";
import Typography from "../Typography";

export type DashboardHeaderProps = {
  role?: string;
  date: Date;
  type?: "aiReports" | "studiesToRead";
};

const DashboardHeader: FC<DashboardHeaderProps> = ({
  role,
  date,
  type = "studiesToRead",
}) => {
  const { titleCenterServicesToRead, titleAiReports, titleAdmin } =
    useTranslations();

  const title = useMemo(() => {
    switch (type) {
      case "aiReports":
        return titleAiReports;
      case "studiesToRead":
        return titleCenterServicesToRead;
      default:
        return titleCenterServicesToRead;
    }
  }, [type, titleAiReports, titleCenterServicesToRead]);

  switch (role) {
    case "receptionist":
    case "technologist":
      return <DateTypographyHeader date={date} />;
    case "radiologist":
      return <Typography variant="h2">{title}</Typography>;
    case "regional_admin":
    case "super_admin":
      return <Typography variant="h2">{titleAdmin}</Typography>;
    default:
      return null;
  }
};

export default DashboardHeader;
